import React, { useState } from "react";
import { X } from "lucide-react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Spinner } from "reactstrap";

import * as api from "services/api";

import StyledModal from "components/StyledModal";

import ls from "Localization";

import { ButtonsContainer, ModalBody, ModalHeader, Separator } from "./styles";

export function UpdateStatusModal({
	isModalOpen,
	setIsModalOpen,
	previousStatus,
	newStatus,
	onStatusUpdated
}) {
	const [isLoading, setIsLoading] = useState(false);

	const { id } = useParams();

	const { token } = useSelector(s => s.login);

	async function handleStatusUpdate() {
		try {
			setIsLoading(true);

			const response = await api.sendPut(
				`/contract-solicitation/change-status/${id}`,
				{
					newStatus
				},
				{
					Authorization: "Bearer " + token
				}
			);

			if (response.ok) {
				toast.success("Status da solicitação atualizado com sucesso.");
				setIsModalOpen(false);
				onStatusUpdated && onStatusUpdated();
			} else {
				toast.error(
					"Houve um erro ao atualizar o status da solicitação. Tente novamente mais tarde."
				);
			}
		} catch (error) {
			toast.error(
				"Houve um erro ao atualizar o status da solicitação. Tente novamente mais tarde."
			);
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	}

	return (
		<StyledModal open={isModalOpen} handleClose={() => setIsModalOpen(false)}>
			<ModalHeader>
				<p>Confirme esta ação</p>
				<button onClick={() => setIsModalOpen(false)}>
					<X size={24} color="#8e8e93" />
				</button>
			</ModalHeader>

			<Separator />

			<ModalBody>
				<h1>Deseja alterar o status da solicitação?</h1>

				<p>
					Você está mudando o status de <strong>{ls[previousStatus]}</strong>{" "}
					para <strong>{ls[newStatus]}.</strong>
				</p>
			</ModalBody>

			<ButtonsContainer>
				<button onClick={() => setIsModalOpen(false)} disabled={isLoading}>
					Cancelar
				</button>
				<button onClick={handleStatusUpdate} disabled={isLoading}>
					{isLoading ? <Spinner size="sm" /> : "Confirmar"}
				</button>
			</ButtonsContainer>
		</StyledModal>
	);
}
